import React, {useEffect, useState} from 'react';
import {Link, Outlet} from 'react-router-dom'
import Header from "./header/header";
import Footer from "./footer/footer";
import { ScrollOnTop } from '../shared/utils/scrollOnTop/scrollOnTop';
import {useAuth} from "./authProvider/authProvider";
import ModalCookie from "./modal_cookie/modal_cookie";


const Layout = () => {
    const authContext = useAuth()
    const [showModal, setShowModal] = useState(false)

    useEffect(() => {
        const cookieAccepted = localStorage.getItem('cookie-accepted');
        if (!cookieAccepted) {
            setShowModal(true);
        }
    }, []);

    const handleAcceptCookies = () => {
        localStorage.setItem('cookie-accepted', 'true');
        setTimeout(() => {
            setShowModal(false)
        }, 500)
    };

    return (
        <div className='container'>
            <ScrollOnTop/>
            <header>
                <Header/>
            </header>

            <Outlet />

            {showModal && (
                <ModalCookie
                    active={showModal}
                    close={() => setShowModal(false)}
                    onAccept={handleAcceptCookies}
                />
            )}

            <footer>
                <Footer/>
            </footer>
        </div>
    );
};

export {Layout};